import { RESULT_CODE } from '@/api/result_code';
import { useLoader } from '@/hooks/use_loader';
import { campaign } from '@/json/json_loader';
import { ActionBase } from '@/models/action_base';
import { KbnConst } from '@/utils/kbn';

import { useActionDataClear } from './use_action_data_clear';
import { useApi } from './use_api';
import { useFileUpload } from './use_file_upload';
import { useInsertDataStore } from './use_insert_data_store';
import { useRouting } from './use_routing';
import { useSurvey } from './use_survey';
export class ActionReceiptUpload extends ActionBase {
  typeKbn = KbnConst.ACTION_TYPE_KBN_RECEIPT_UPLOAD;

  use() {
    const insertDataStore = useInsertDataStore();
    const survey = useSurvey();
    const routing = useRouting();
    const actionDataClear = useActionDataClear();
    return async () => await execute(
      insertDataStore,
      survey,
      routing,
      actionDataClear,
    );

  }

  constructor(init: Partial<ActionReceiptUpload> = {}) {
    super();
    Object.assign(this, init);
  }
}

export async function execute(
  insertDataStore: ReturnType<typeof useInsertDataStore>,
  survey: ReturnType<typeof useSurvey>,
  routing: ReturnType<typeof useRouting>,
  actionDataClear: ReturnType<typeof useActionDataClear>,
) {
  const loader = useLoader();
  const api = useApi();
  const { fileCache } = useFileUpload();

  if (!fileCache.value) return true; // ファイルが無い場合はアクション中断
  // surveyデータがあれば追加
  const surveyData = survey.getPostData();
  if (surveyData) {
    insertDataStore.survey.value = surveyData;
  }
  loader.start();
  try {
    const { presignedUrl, receiptUuid } = (await api.getReceiptUploadUrl()).dataJson;
    await api.uploadFile(presignedUrl, fileCache.value, { 'x-amz-acl': 'public-read' });
    const insertDataStore = useInsertDataStore();
    const response = await api.postReceipt(receiptUuid, {
      ...insertDataStore.getValues(),
    });

    // アンケートのバリデーションエラーの場合、エラーページに遷移させる
    if (response.resultCode === RESULT_CODE.SURVEY_EMPTY_ANSWER
      || response.resultCode === RESULT_CODE.DUPLICATED_FIRST_ANSWERED_SURVEY
      || response.resultCode === RESULT_CODE.SURVEY_EMPTY_REQUIRED_FIELD
      || response.resultCode === RESULT_CODE.SURVEY_EMPTY_ANSWER
    ) {
      await routing.redirect('error');
      fileCache.value = undefined;
      return true;
    }
    const entryPollingResponse = await api.getEntryPolling(receiptUuid, true);
    if (entryPollingResponse && entryPollingResponse.responseCandidateUuid) {
      // データクリア
      await actionDataClear();
      const uuid = entryPollingResponse.responseCandidateUuid;
      const page = campaign.responseCandidates.find(x => x.uuid === uuid)?.pageName;
      if (page) {
        await routing.redirect(page);
        fileCache.value = undefined;
        return true;
      }
    }

    // 返信グループに落ちなかった場合エラーページに遷移
    fileCache.value = undefined;

    // receiptUuid.value = null;
    throw new Error('receiptアップロード後の抽選結果反映に失敗しました');
  } finally {
    loader.stop();
  }

}
